// src/App.js
import React from "react";
import { HashRouter as Router, Routes, Route, Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import Home from "./Home";
import Gallery from "./Gallery";
import Contact from "./Contact";
import ArtPiece from "./ArtPiece";
import Store from "./Store";
import Blog from "./Blog";
import DoodleWall from "./DoodleWall";
import Splash from "./Splash";
import "./styles.css";
import logo from "./assets/logo.png";
import BoomboxButton from "./BoomboxButton";

function SiteShell() {
  return (
    <>
      {/* Masthead holds logo + nav + boombox */}
      <div className="masthead">
        <div className="logo-container">
          <Link to="/home">
            <img src={logo} alt="Minminmachine Logo" className="logo-image" />
          </Link>
        </div>

        {/* boombox now lives inside the masthead and will scroll away */}
        <BoomboxButton className="boombox-inline" />

        <Header />
      </div>

      <Routes>
        <Route path="/home" element={<Home />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/doodle" element={<DoodleWall />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/art/:id" element={<ArtPiece />} />
        <Route path="/store" element={<Store />} />
        <Route path="*" element={<Home />} />
      </Routes>

      <Footer />
    </>
  );
}

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Splash />} />
        <Route path="/*" element={<SiteShell />} />
      </Routes>
    </Router>
  );
}
